import { createApp } from 'vue';
import VueLazyload from 'vue-lazyload';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import SerieBlocks from '../pages/SerieBlocks.vue';

import PostItem from '../components/PostItem.vue';

class SerieBlocksComponent {
  constructor({ container, serieBlockId, serieId }) {
    this.app = null;
    this.container = container;
    this.serieBlockId = serieBlockId;
    this.serieId = serieId;
  }

  init() {
    const props = { serieBlockId: this.serieBlockId, serieId: this.serieId }
    this.app = createApp(SerieBlocks, props);
    this.app.use(I18NextVue, { i18next });
    this.app.use(VueLazyload, {
      preLoad: 2.6 // default 1.3
    });

    this.app.component('post-item', PostItem);
    this.app.mount(this.container);
  }
}

export default SerieBlocksComponent;
